module.exports = __webpack_public_path__ + "static/media/lv2_greyscale.d3dcace4.jpg";